export const GET_SETTINGS_BASE = 'GET_SETTINGS_BASE';
export const GET_SETTINGS_BASE_LOADING = 'GET_SETTINGS_BASE_LOADING';
export const GET_SETTINGS_BASE_ERROR = 'GET_SETTINGS_BASE_ERROR';

export const UPDATE_SETTINGS_BASE = 'UPDATE_SETTINGS_BASE';
export const UPDATE_SETTINGS_BASE_LOADING = 'UPDATE_SETTINGS_BASE_LOADING';
export const UPDATE_SETTINGS_BASE_ERROR = 'UPDATE_SETTINGS_BASE_ERROR';
export const UPDATE_SETTINGS_BASE_RESET_STATE = 'UPDATE_SETTINGS_BASE_RESET_STATE';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_LOADING = 'GET_COUNTRIES_LOADING';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

export const GET_COUNTRIES_BY_ID = 'GET_COUNTRIES_BY_ID';
export const GET_COUNTRIES_BY_ID_LOADING = 'GET_COUNTRIES_BY_ID_LOADING';
export const GET_COUNTRIES_BY_ID_ERROR = 'GET_COUNTRIES_BY_ID_ERROR';

export const CREATE_COUNTRIES = 'CREATE_COUNTRIES';
export const CREATE_COUNTRIES_LOADING = 'CREATE_COUNTRIES_LOADING';
export const CREATE_COUNTRIES_ERROR = 'CREATE_COUNTRIES_ERROR';
export const CREATE_COUNTRIES_RESET_STATE = 'CREATE_COUNTRIES_RESET_STATE';

export const UPDATE_COUNTRIES_BY_ID = 'UPDATE_COUNTRIES_BY_ID';
export const UPDATE_COUNTRIES_BY_ID_LOADING = 'UPDATE_COUNTRIES_BY_ID_LOADING';
export const UPDATE_COUNTRIES_BY_ID_ERROR = 'UPDATE_COUNTRIES_BY_ID_ERROR';

export const CREATE_CURRENCIES = 'CREATE_CURRENCIES';
export const CREATE_CURRENCIES_LOADING = 'CREATE_CURRENCIES_LOADING';
export const CREATE_CURRENCIES_ERROR = 'CREATE_CURRENCIES_ERROR';

export const GET_CURRENCIES = 'GET_CURRENCIES';
export const GET_CURRENCIES_LOADING = 'GET_CURRENCIES_LOADING';
export const GET_CURRENCIES_ERROR = 'GET_CURRENCIES_ERROR';

export const UPDATE_CURRENCIES_BY_ID = 'UPDATE_CURRENCIES_BY_ID';
export const UPDATE_CURRENCIES_BY_ID_LOADING = 'UPDATE_CURRENCIES_BY_ID_LOADING';
export const UPDATE_CURRENCIES_BY_ID_ERROR = 'UPDATE_CURRENCIES_BY_ID_ERROR';

export const GET_CITIES_BY_COUNTRY = 'GET_CITIES_BY_COUNTRY';
export const GET_CITIES_BY_COUNTRY_LOADING = 'GET_CITIES_BY_COUNTRY_LOADING';
export const GET_CITIES_BY_COUNTRY_ERROR = 'GET_CITIES_BY_COUNTRY_ERROR';

export const CREATE_CITIES_BY_COUNTRY = 'CREATE_CITIES_BY_COUNTRY';
export const CREATE_CITIES_BY_COUNTRY_LOADING = 'CREATE_CITIES_BY_COUNTRY_LOADING';
export const CREATE_CITIES_BY_COUNTRY_ERROR = 'CREATE_CITIES_BY_COUNTRY_ERROR';

export const UPDATE_CITIES_BY_COUNTRY = 'UPDATE_CITIES_BY_COUNTRY';
export const UPDATE_CITIES_BY_COUNTRY_LOADING = 'UPDATE_CITIES_BY_COUNTRY_LOADING';
export const UPDATE_CITIES_BY_COUNTRY_ERROR = 'UPDATE_CITIES_BY_COUNTRY_ERROR';

export const UPDATE_COUNTRIES_RESET_STATE = 'UPDATE_COUNTRIES_RESET_STATE';